<template functional>
  <div>
    <p>
      Use the ICO Manager to create new Ideal Career Opportunity (ICO) profiles
      or modify the terms of an existing ICO profile any time your desired job
      terms change.
    </p>
    <p>
      You have a menu of terms to select from when building a profile. All ICOs
      must include our Core Terms (Desired Location, Minimum Total Compensation,
      and Practice Type). You can then select any Additional Terms to complete
      your profile.
    </p>
    <p>
      Use the ‘pencil’ to select your desired value for any term. Once selected,
      the middle workspace will display current market information for that
      term, so you can be informed when you set your own term. Once the term is
      defined, click “Save Preference.”
    </p>
    <p>
      Use the pencil to set your desired value for a career item. Once selected,
      the middle workspace will display current market information for that
      career term, and prompt you to set your term. Once defined, click “Save
      Preference” and your desired career term will appear in the applicable
      menu card in the left margin.
    </p>
    <p>
      Once you are satisfied your ICO profile is complete, click “Post to
      Exchange” and your ICO will appear on the Connect exchange.
    </p>
    <p>
      <u>Note</u>: Connect is not yet open to job offerors. We will notify you
      when it is open.
    </p>
  </div>
</template>

<script>
export default {
  name: 'JobProfileInfoPopup',
};
</script>

<style scoped></style>
